import React, { useState, useMemo, useEffect }  from 'react'
import classNames from 'classnames'

import GridListTdSelectable from './GridListTdSelectable'
import GridListTd from './GridListTd'
import GridListTdActions from './GridListTdActions'

const GridListRow = ({ item, sortedBy, selectedIds, onRowSelect, renderedColumns, disabled, disabledClick, isBordered, gridProps = {} }) => {
  const { rowProps = {}, color, gridView, isCompact, isNarrow, disableMobile, showManageColumns } = gridProps
  const { rowSelectable, rowIcon, rowIconText, rowMenuItems, rowActions, rowActionsAlwaysVisible, rowClick, rowBlank, rowId = '_id', setAsSelectedIds = [] } = rowProps
  const setIcon = typeof rowIcon === 'function' ? rowIcon(item) : rowIcon
  const actionsAlwaysVisible = typeof rowActionsAlwaysVisible === 'function' ? rowActionsAlwaysVisible(item) : !!rowActionsAlwaysVisible

  return (
    <tr
      className={
        classNames(
          'viso-grid-list-table__body-row',
          `viso-grid-list-table__body-row--${gridView}`,
          disabledClick && 'viso-grid-list-table__body-row--disabled-click',
          rowClick && 'viso-grid-list-table__body-row--clickable',
          !rowBlank && selectedIds.includes(item[rowId]) && `viso-bg-${color}-10`,
          !rowBlank && setAsSelectedIds.includes(item[rowId]) && `viso-bg-${color}-10`,
          !disableMobile && 'viso-grid-list-table__body-row--mobile-enabled',
          disableMobile && gridView === 'card' && 'viso-grid-list-table__body-row--card--full',
          rowBlank && 'viso-grid-list-table__body-row--blank',
          isBordered && 'viso-grid-list-table__body-row--bordered',
          disabled && 'disabled-event'
        )
      }
      onClick={() => !disabledClick && rowClick && rowClick(item, onRowSelect)}
    >
      {(rowSelectable || rowIcon || rowIconText) &&
        <GridListTdSelectable
          onSelect={(e) => {
            if (!rowBlank && rowSelectable && !disabledClick) {
              e.stopPropagation()
              onRowSelect(item)
            }
          }}
          icon={!rowBlank && setIcon}
          iconText={(!rowBlank && rowIconText) && rowIconText(item)}
          color={color}
          isChecked={rowBlank ? false : selectedIds.includes(item[rowId]) || setAsSelectedIds.includes(item[rowId])}
          gridView={gridView}
          disableMobile={disableMobile}
          disabledClick={disabledClick}
        />
      }
      {rowBlank ?
        <GridListTd
          gridView={gridView}
          isCompact={isCompact}
          isNarrow={isNarrow}
          disableMobile={disableMobile}
          rowBlank={rowBlank}
          disabledClick={disabledClick}
          isBordered={isBordered}
        />
        :
        renderedColumns.map(def => def.isVisible &&
          <GridListTd
            key={def.column}
            def={def}
            item={item}
            color={color}
            sortedBy={sortedBy}
            gridView={gridView}
            isCompact={isCompact}
            isNarrow={isNarrow}
            disableMobile={disableMobile}
            disabledClick={disabledClick}
            isBordered={isBordered}
          />
        )
      }
      {!rowBlank && (rowMenuItems?.length > 0 || rowActions?.length > 0 || showManageColumns) &&
        <GridListTdActions
          itemData={item}
          menuItems={rowMenuItems}
          actions={rowActions}
          actionsAlwaysVisible={actionsAlwaysVisible}
          color={color}
          gridView={gridView}
          disableMobile={disableMobile}
          isBordered={isBordered}
        />
      }
    </tr>
  )
}

export default GridListRow